import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Network3Reference"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M3 15V16.5H6.4395L1.5 21.4395 2.5605 22.5 7.5 17.5605V21H9V15H3zM22.5 22.5H16.5V16.5H22.5V22.5zM18 21H21V18H18V21zM15 15H9V9H15V15zM10.5 13.5H13.5V10.5H10.5V13.5z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M18 12.75H16.5V11.25H18C18.7956 11.25 19.5587 10.9339 20.1213 10.3713 20.6839 9.80871 21 9.04565 21 8.25 21 7.45435 20.6839 6.69129 20.1213 6.12868 19.5587 5.56607 18.7956 5.25 18 5.25H9V3.75H18C19.1935 3.75 20.3381 4.22411 21.182 5.06802 22.0259 5.91193 22.5 7.05653 22.5 8.25 22.5 9.44347 22.0259 10.5881 21.182 11.432 20.3381 12.2759 19.1935 12.75 18 12.75zM7.5 7.5H1.5V1.5H7.5V7.5zM3 6H6V3H3V6z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Network3Reference.vue"]]);
